import React, { useContext } from "react";
import { Route as RouterRoute, Redirect } from "react-router-dom";

import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";
import rules from "../rules";

const checkPermission = (role, action) => {
  const permissions = rules[role];

  if (!permissions) {
    return false;
  }

  const staticPermissions = permissions.static;

  if (staticPermissions && staticPermissions.includes(action)) {
    return true;
  }

  const dynamicPermissions = permissions.dynamic;

  if (dynamicPermissions) {
    const permissionCondition = dynamicPermissions[action];

    if (!permissionCondition) {
      return false;
    }

    return permissionCondition();
  }

  return false;
};

const Route = ({
  component: Component,
  isPrivate = false,
  requiredPermission,
  ...rest
}) => {
  const { isAuth, loading, user } = useContext(AuthContext);

  if (!isAuth && isPrivate) {
    return (
      <>
        {loading && <BackdropLoading />}
        <Redirect to={{ pathname: "/login", state: { from: rest.location } }} />
      </>
    );
  }

  if (isAuth && !isPrivate) {
    return (
      <>
        {loading && <BackdropLoading />}
        <Redirect to={{ pathname: "/", state: { from: rest.location } }} />;
      </>
    );
  }

  if (isPrivate && requiredPermission) {
    const role = user?.profile;
    const isAllowed = role && checkPermission(role, requiredPermission);

    if (!isAllowed) {
      return (
        <>
          {loading && <BackdropLoading />}
          <Redirect to={{ pathname: "/", state: { from: rest.location } }} />
        </>
      );
    }
  }

  return (
    <>
      {loading && <BackdropLoading />}
      <RouterRoute {...rest} component={Component} />
    </>
  );
};

export default Route;
